/* app/js/src/components/common/head-phone/head-phone.component.scss */
/*# sourceMappingURL=head-phone.component.css.map */
